import TableWithCheckboxes from "../../../../../ui/tables/table-with-checkboxes/TableWithCheckboxes";
import {headCells} from "./ParametriESimTableHelper";
import {Grid, IconButton, TableCell, TableRow, Tooltip} from "@material-ui/core";
import EmptyRow from "../../../../../ui/tables/rows/empty-row/EmptyRow";
import Checkbox from "@material-ui/core/Checkbox";
import {returnSelectedRows} from "../../../../../../shared/utils/tableUtils";
import PropTypes from "prop-types";
import ESimIcon from "../../../../../../assets/images/icon-content-esim-24-px.svg";
import HelpIcon from "@material-ui/icons/Help";
import {useSelector} from "react-redux";
import {addPlusForMsisdn} from "../../../../../../shared/utils/utils";
import TagsCell from "../../../sim/tabs/attive/attive-table/tags-cell/TagsCell";

const EsitoInvioEmailTable = (props) => {
    const tableData = useSelector(state => state.eSimReducer.parametriESimTableData.data);
    const totalTableData = useSelector(state => state.eSimReducer.parametriESimTableData.total);
    const tableLoading = useSelector(state => state.eSimReducer.parametriESimTableData.loading);

    const handleCheckboxClick = (e, row) => {
        e.stopPropagation()
        const selectedIndex = props.selected.findIndex(i => i.id === row.id);
        props.setSelected(returnSelectedRows(props.selected, row, selectedIndex));

    }

    const openVerificaDialog = (row) => {
        props.setOpenVerificaDialog(true)
        props.setVerificaSim(row)
    }

    const isSelected = (id) => props.selected.some(d => d.id === id);

    const tableRows = (
        tableData.length !== 0 ?
            tableData.map((row, idx) => {
                const isItemSelected = isSelected(row.id);
                const labelId = `esito-invio-email-table-checkbox-${idx}`;

                return (
                    <TableRow
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={row.id} hover
                        selected={isItemSelected}
                        onClick={() => openVerificaDialog(row)}
                    >
                        <TableCell padding="checkbox">
                            <Checkbox
                                checked={isItemSelected}
                                onClick={(e) => handleCheckboxClick(e, row)}
                                inputProps={{'aria-labelledby': labelId}}
                            />
                        </TableCell>
                        <TableCell align="left">
                            <Grid container
                            style={{marginLeft: 0}}
                            spacing={2}
                            alignItems="center">
                                {row.numeroDiTelefono ? (
                                <>
                                    {addPlusForMsisdn(row.numeroDiTelefono)}
                                    <img src={ESimIcon} alt='eSim' />
                                </>
                                ) : (
                                <Tooltip title={row.numTelefonoPopupText} arrow>
                                   <IconButton size={"small"}>
                                        <HelpIcon color="primary" fontSize="small"/>
                                    </IconButton>
                                </Tooltip>
                                )}
                            </Grid>
                        </TableCell>
                        <TableCell align="left">{row.seriale}</TableCell>
                        <TableCell align="left">{row.statoSim}</TableCell>
                        <TableCell align="left">{row.dataInvio}</TableCell>
                        <TableCell align="left">{row.emailInviata}</TableCell>
                        {row.tags ? <TagsCell tags={row.tags?.tags}/> : <TableCell/>}
                    </TableRow>
                )
            }) : <EmptyRow text="dato" colSpan={headCells.length + 2}/>
    )

    return (
        <TableWithCheckboxes
            selected={props.selected}
            setSelected={props.setSelected}
            page={props.page}
            rowsPerPage={props.rowsPerPage}
            fetchData={props.handlePaginationChange}
            count={totalTableData}
            loading={tableLoading}
            tableRows={tableRows}
            rows={tableData}
            headCells={headCells}
            selectAllRows={props.areAllSelected}
            setSelectAllRows={props.setAreAllSelected}
        />
    )
};

EsitoInvioEmailTable.propTypes = {
    selected: PropTypes.array.isRequired,
    setSelected: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    handlePaginationChange: PropTypes.func.isRequired,
    areAllSelected: PropTypes.bool.isRequired,
    setAreAllSelected: PropTypes.func.isRequired,
    setOpenVerificaDialog: PropTypes.func.isRequired,
}

export default EsitoInvioEmailTable;
